import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { useEffect } from "react";
import { Route, Switch, useLocation, useParams } from "wouter";
import { RuleCreateView } from "./rule-create.view";
import { RuleUpdateView } from "./rule-uuid-update.view";

function RedirectToGroupRoot() {
  const params = useParams<{ groupUuid: string }>();
  const [, navigate] = useLocation();

  useEffect(() => {
    if (!params.groupUuid) return;
    navigate(`~/ram/group/${params.groupUuid}`, { replace: true });
  }, [navigate, params.groupUuid]);

  return null;
}

export function RuleRoutes() {
  const ruleUuidUpdateRegex = generateUuidV4Regex({
    paramName: "ruleUuid",
    suffix: "/update",
  });
  return (
    <Switch>
      <Route path="/" component={RedirectToGroupRoot} />
      <Route path={"/create"} component={RuleCreateView} />
      <Route path={ruleUuidUpdateRegex} component={RuleUpdateView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
